import React from 'react';
import Box from '@material-ui/core/Box';

const Wrap = props => {
  const { children, maxWidth, noPadding, ...rest } = props;
  return (
    <Box {...rest}>
      <Box
        height="100%"
        maxWidth={maxWidth}
        margin="auto"
        component="section"
        pt={noPadding ? 0 : 8}
        pb={noPadding ? 0 : 8}
        pr={2}
        pl={2}
      >
        {children}
      </Box>
    </Box>
  );
};

Wrap.defaultProps = {
  maxWidth: 1140,
  noPadding: false,
};

export default Wrap;
